export default [
  {
    path: "/sxfgeQaJ51OP00nLALkd",
    children: [
    {
        path: "staff",
        name: "staffList",
        meta: {
          title: "Staff",
          authRequired: true,
          acc: ["y67982"],
        },
        component: () => import("../views/staff/list.vue"),
      },
      {
        path: "staff/:tr",
        name: "viewStaff",
        meta: {
          title: "View Staff",
          authRequired: true,
          acc: ["y68075"],
        },
        component: () => import("../views/staff/view.vue"),
      },
      {
        path: "update/:tr",
        name: "updateStaff",
        meta: {
          title: "Update Staff",
          authRequired: true,
          acc: ["y79424"],
        },
        component: () => import("../views/staff/update.vue"),
      },
      {
        path: "updatep/:tr",
        name: "updateStaffPassword",
        meta: {
          title: "Update Staff Password",
          authRequired: true,
          acc: ["y79424"],
        },
        component: () => import("../views/staff/updatePassword.vue"),
      },
      {
        path: "updater/:tr",
        name: "updateStaffRole",
        meta: {
          title: "Update Staff Role",
          authRequired: true,
          acc: ["y79424"],
        },
        component: () => import("../views/staff/updateRole.vue"),
      },
      {
        path: "new",
        name: "newStaff",
        meta: {
          title: "New Staff",
          authRequired: true,
          acc: ["y76403"],
        },
        component: () => import("../views/staff/new.vue"),
      },
      
      
    ],
  },
];
